import sc from 'styled-components';
import React from 'react';
import { Icon, Input } from 'antd';
import _ from 'lodash';

const SearchFrame = sc.div`
   width: 100%;
   display: flex;
   flex-direction: row;
   justify-content: flex-end;
`;

const Inner = sc.div`
   max-width: 250px;
`;

export default ({ value, onChange }) => (
  <SearchFrame data-type="search-frame">
    <Inner>
      <Input.Search
        tabIndex={-1}
        value={value}
        placeholder="search"
        onChange={event => onChange(_.get(event, 'target.value'))}
        addonAfter={<div onClick={() => onChange('')}><Icon type="close" /></div>}
      />
    </Inner>
  </SearchFrame>);
